import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom'; 
import Home from './components/Home';
import OTP from './components/OTP';
import NOCOTP from './components/NOCOTP';
import Dashboard from './components/Dashboard';
import Main from './pages/Main';
import CardManagement from './components/CardManagement';
import StatementGeneration from './components/StatementGeneration';
import CardManage from './pages/CardManage';
import Statements from './pages/Statements';
import CardBlock from './pages/CardBlock';
import UnBlocks from './pages/UnBlocks';
import CardReplace from './pages/CardReplace';
import TaxCertificates from './pages/TaxCertificates';
import TemporaryCardBlock from './components/TemporaryCardBlock';
import UnblockCard from './components/UnblockCard';
import CardReplacement from './components/CardReplacement';
import TaxCertificate from './components/TaxCertificate';
import CashBack from './components/CashBack';
import CardBlockManagement from './components/CardBlockManagement';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import DevToolsBlocker from './components/DevToolsBlocker';
import { validateAndRefreshSession, updateLastActivity } from './utils/auth';
import './App.css';

const App = () => {
    // currentLocation avoids the 'no-restricted-globals' ESLint error
    const currentLocation = useLocation();

    useEffect(() => {
        const activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
        const handleUserActivity = () => {
            const token = localStorage.getItem('accessToken');
            if (token) updateLastActivity();
        };

        activityEvents.forEach(event => document.addEventListener(event, handleUserActivity, true));

        const handleVisibilityChange = () => {
            if (!document.hidden) {
                const token = localStorage.getItem('accessToken');
                if (token) validateAndRefreshSession();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            activityEvents.forEach(event => document.removeEventListener(event, handleUserActivity, true));
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    // Define paths where the header SHOULD NOT appear
    const hideHeaderPaths = ['/', '/otp', '/noc'];
    const shouldHideHeader = hideHeaderPaths.includes(currentLocation.pathname);

    return (
        <>
            {/* Blocks the UI and shows a message when DevTools are open (production only) */}
            <DevToolsBlocker />

            {/* Header only renders if current path is NOT in the hide list */}
            {!shouldHideHeader && <Header />}
            
            {/* Padding-top (pt-20) is removed if header is hidden */}
            <main className={`${!shouldHideHeader ? "pt-20" : ""} min-h-screen bg-gray-50`}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/main" element={<ProtectedRoute><Main /></ProtectedRoute>} />
                    <Route path="/tax-certificate" element={<ProtectedRoute><TaxCertificate /></ProtectedRoute>} />
                    <Route path="/taxcertificate" element={<ProtectedRoute><TaxCertificates /></ProtectedRoute>} />
                    <Route path="/cardReplace" element={<ProtectedRoute><CardReplace /></ProtectedRoute>} />
                    <Route path="/cardManage" element={<ProtectedRoute><CardManage /></ProtectedRoute>} />
                    <Route path="/statements" element={<ProtectedRoute><Statements /></ProtectedRoute>} />
                    <Route path="/cardBlock" element={<ProtectedRoute><CardBlock /></ProtectedRoute>} />
                    <Route path="/unBlocks" element={<ProtectedRoute><UnBlocks /></ProtectedRoute>} />
                    <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                    <Route path="/otp" element={<OTP />} />
                    <Route path="/noc" element={<ProtectedRoute><NOCOTP /></ProtectedRoute>} />
                    <Route path="/cardManagement" element={<ProtectedRoute><CardManagement /></ProtectedRoute>} />
                    <Route path="/statementGeneration" element={<ProtectedRoute><StatementGeneration /></ProtectedRoute>} />
                    <Route path="/temporary-block" element={<ProtectedRoute><TemporaryCardBlock /></ProtectedRoute>} />
                    <Route path="/Un-block" element={<ProtectedRoute><UnblockCard /></ProtectedRoute>} />
                    <Route path="/block-unblock" element={<ProtectedRoute><CardBlockManagement /></ProtectedRoute>} />
                    <Route path="/cardReplacement" element={<ProtectedRoute><CardReplacement /></ProtectedRoute>} />
                    <Route path="/cashBack" element={<ProtectedRoute><CashBack /></ProtectedRoute>} />
                </Routes>
            </main>
        </>
    );
};

export default App;
